<template>
    <div class="discounts-and-offers">
        <h1>{{ $t("Discounts and promotions") }}</h1>
        <div class="discount_row">
            <div class="description">
                <h3>{{ $t("TELL A FRIEND DISCOUNT") }}</h3>
                <div v-if="getCurrency.currency === 'EUR'">
                    <p><strong>{{ $t("If you’ve been recommended") }}:</strong> 
                        if you’re new or haven’t been for at least three years AND you’ve been recommended by someone with a booking for this season, you get 60 euros off - and so do they. Please give their booking reference or name below.
                    </p>
                </div>
                <div v-else>
                    <p><strong>{{ $t("If you’ve been recommended") }}:</strong> {{ $t("if you’re new or haven’t been for at least three years AND you’ve been recommended by someone with a booking for this season, you get £50 off - and so do they. Please give their booking reference or name below.") }} </p>
                </div>
                <p><strong>{{ $t("If you’re the recommender") }}:</strong> {{ $t("if you’ve recommended new people who have already booked, please give their booking reference(s) or name(s) below") }}</p>
                <input v-model="referals_text" class="inline_input size30" type="text" maxlength="30">

            </div>
            <div class="amount">
                <h4>{{ $t("Amount claimed") }}</h4>
                <input v-model="referals_discount" type="text" size="10">
            </div>
        </div>
        <div class="discount_row">
            <div class="description">
                    <h3>{{ $t("LONE PARENTS DISCOUNT") }}</h3>
                    <div v-if="getCurrency.currency === 'EUR'">
                        Lone parents travelling alone with children save 115 euros per week – any week of the season. Special welcome for single parents during half term week – call us or see website for details.
                    </div>
                    <div v-else>
                        {{ $t("Lone parents travelling alone with children save £60 per week – any week of the season. Special welcome for single parents during half term week – call us or see website for details.") }}
                    </div>
            </div>
            <div class="amount">
                    <h4>{{ $t("Amount claimed") }}</h4>
                    <input v-model="lone_parents_discount" type="text" size="10">
            </div>
        </div>
        <div class="discount_row" v-if="false">
            <div class="description">
                    <h3>{{ $t("SINGLES AND COUPLES") }}</h3>
                    {{ $t("Save 30% off accommodation in a Pinewood 2 or Evergreen 2 mobile home, starting any time in June (so long as no more than two people are on the booking).") }}
            </div>
            <div class="amount">
                    <h4>{{ $t("Amount claimed") }}</h4>
                    <input v-model="singles_and_couples" type="text" size="10">
            </div>
        </div>
        <div class="discount_row">
            <div class="description">
                    <h3>{{ $t("PROMOTIONAL DISCOUNT") }}</h3>
                    {{ $t("Please enter the discount code here:") }}
                    <input v-model="promotional_discount_text" class="inline_input size30" type="text" maxlength="30">
            </div>
            <div class="amount">
                    <h4>{{ $t("Amount claimed") }}</h4>
                    <input v-model="promotional_discount" type="text" size="10">
            </div>
        </div>
        <div class="discount_row" v-if="getTransportDiscount!=0">
            <div class="description">
                <h3>{{ $t("OWN TRANSPORT DISCOUNT") }}</h3>
                {{ $t("We apply this discount if you have chosen not to book Channel crossings with us.") }}
            </div>
            <div class="amount">
                <h4>{{ $t("Amount claimed") }}</h4>
                <input disabled v-model="getTransportDiscount" type="text" size="10">
            </div>
        </div>
        <div class="discount_row">
            <div class="description">
                <h3>{{ $t("TOTAL CLAIMED") }}</h3>
                {{ $t("This amount will be deducted from your holiday price but remains subject to verification. Your final price will be confirmed in your invoice.") }}
            </div>
            <div class="amount">
                <input disabled v-model="totalDiscounts" type="text" size="10">
            </div>
        </div>        
    </div>
        <div class="continue_button">
            <button class="button blue" v-if="false">Phone me</button> &nbsp; 
            
            <button
            href="#"
            class="button blue"
            :disabled="hasInvalidFields"
            @click.prevent="continueToSummary">{{ $t("Continue") }} &gt;&gt;</button> 

        </div>      
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        data() {
            return {
                referals_text: '',
                referals_discount: '',
                lone_parents_discount: '',
                singles_and_couples: '',
                promotional_discount_text: '',
                promotional_discount: '',
            }
        },
        computed: {
            ...mapGetters([
                'getDiscounts',
                'getBookingDetails',
                'getCurrency',
            ]),        

            hasInvalidFields() {
                return false;
            },
            getTransportDiscount(){
                return -this.getBookingDetails.transport_discount;
            },
            totalDiscounts() {
                let getTransportDiscount= 0+this.getTransportDiscount || 0;
                console.log('getTransportDiscount',parseInt(getTransportDiscount));
                let referals_discount= 0+this.referals_discount || 0;
                console.log('referals_discount',parseInt(referals_discount));
                let lone_parents_discount= 0+this.lone_parents_discount || 0;
                console.log('lone_parents_discount',parseInt(lone_parents_discount));
                let singles_and_couples= 0+this.singles_and_couples || 0;
                console.log('singles_and_couples',parseInt(singles_and_couples));
                let promotional_discount= 0+this.promotional_discount || 0;
                console.log('promotional_discount',parseInt(promotional_discount));
                return parseInt(getTransportDiscount)+ parseInt(referals_discount)+ parseInt(lone_parents_discount)+ parseInt(singles_and_couples)+ parseInt(promotional_discount);
                ;
            },
        },
        methods: {
            continueToSummary() {
                this.saveDiscounts();
                this.$store.commit('CHANGE_PROGRESS_STEP',5);
                this.$router.push({name: "SummaryAndConfirmation",hash:'#appTop'});

                
            },
            loadDiscounts(){
                // console.log('loadDiscounts',this.getDiscounts.referals_text)
                this.referals_text=this.getDiscounts.referals_text;
                this.referals_discount=this.getDiscounts.referals_discount;
                this.lone_parents_discount=this.getDiscounts.lone_parents_discount;
                this.singles_and_couples=this.getDiscounts.singles_and_couples;
                this.promotional_discount_text=this.getDiscounts.promotional_discount_text;
                this.promotional_discount=this.getDiscounts.promotional_discount;
            },
            saveDiscounts(){
                console.log('saveDiscounts')
                this.$store.commit('UPDATE_DISCOUNTS',
                    {
                        'referals_text':this.referals_text,
                        'referals_discount':this.referals_discount,
                        'lone_parents_discount':this.lone_parents_discount,
                        'singles_and_couples':this.singles_and_couples,
                        'promotional_discount_text':this.promotional_discount_text,
                        'promotional_discount':this.promotional_discount,
                    }
                );
            }
        },
        mounted() {
            if (this.getCurrency.PriceTypeID==9) {
                this.continueToSummary();
            }
        },
        created () {
            this.loadDiscounts();
        }
    }

</script>

<style scoped>
    .discount_row:nth-child(2n) {
        background-color:#f6e08c;
    }
    .discount_row {
        width: 100%;
        display:flex;
        /* flex-wrap: wrap; */
        justify-content: space-between;
    }
    .description {
        min-width: 250px;
        
        flex:1 auto;
    }
    .amount {
        min-width: 115px;
    }
    div {
        /* border:1px solid black; */
        padding: 3px;
    }
    input {
        width: 96%;
        padding-bottom: 5px;
    }
    @media (max-width: 576px) {
        
        .discount_row {
            flex-wrap: wrap;
            justify-content:flex-end;
        }
        input {
            margin-bottom: 0;
        }
    }
    /* .size30 {
        width: 400px;
    }
    tr td{
        padding-bottom: 15px;
    }
    tr:nth-child(2n) {
        background-color: rgb(246, 224, 140);
    }
    td input {
        margin: 3px 0 0;
    } */
</style>
